import React from "react";
import voyageindigo from "../assets/images/voyageindigo.webp"
import voyageemirates from "../assets/images/voyageemirates.webp";
import voyagephillippines from "../assets/images/voyagephillippines.webp";
import voyageturkish from "../assets/images/voyageturkish.webp";
import voyagetihad from "../assets/images/voyagetihad.webp";
import voyageairarabia from "../assets/images/voyageairarabia.webp";
import voyageairindia from "../assets/images/voyageairindia.webp"

const airlines = [
  {
    name: "Emirates Airlines",
    logo: voyageemirates,
  },
  {
    name: "Etihad Airways",
    logo: voyagetihad,
  },
  {
    name: "Turkish Airlines",
    logo: voyageturkish,
  },
  {
    name: "Air Arabia",
    logo: voyageairarabia,
  },
  {
    name: "Philippine Airlines",
    logo: voyagephillippines,
  },
  {
    name: "IndiGo",
    logo: voyageindigo,
  },
  {
    name: "Air India Express",
    logo: voyageairindia,
  },
];

const AirlinesSlider = () => {
  // Duplicate the cards for seamless infinite scrolling
  const infiniteAirlines = [...airlines, ...airlines];

  return (
    <section className="relative overflow-hidden bg-white py-16 md:scroll-mt-32" id="flights">
      {/* Soft background */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#eefaff] to-white" />

      <div className="relative mx-auto max-w-7xl px-5 md:pt-8">
        <div className="mx-auto mb-2 flex items-center md:justify-center justify-left gap-4">
            <span className=" inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
               Global Airline Partners
              </span>
          </div>

          {/* HEADING */}
          <h2 className="md:text-center text-left md:mt-6 mt-3 text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-[#12344A] sm:text-[48px] md:text-[58px] lg:text-[50px]">
           Fly Further With  <span className="text-[#12344A]">Trusted Airlines.</span>
          </h2>

          {/* DESCRIPTION */}
          <p className="md:text-center text-left mx-auto md:mt-4 mt-2 max-w-3xl text-[16px] font-medium leading-7 text-slate-500 sm:text-[18px] sm:leading-8 lg:text-[20px]">
            Stronger partnerships. More destinations. A world of possibilities
            for your business.
          </p>

        {/* Slider wrapper */}
        <div className="relative md:pt-12 pt-12">
          {/* Left Arrow */}
          {/* <button
            type="button"
            className="absolute left-0 top-1/2 z-20 hidden h-14 w-14 -translate-x-2 -translate-y-1/2 items-center justify-center rounded-full border border-[#9dd9ed] bg-white text-[#2587b5] shadow-sm transition-all hover:bg-[#eefaff] md:flex"
          >
            <i className="las la-arrow-left" />
          </button>

          <button
            type="button"
            className="absolute right-0 top-1/2 z-20 hidden h-14 w-14 translate-x-2 -translate-y-1/2 items-center justify-center rounded-full border border-[#9dd9ed] bg-white text-[#2587b5] shadow-sm transition-all hover:bg-[#eefaff] md:flex"
          >
            <i className="las la-arrow-right" />
          </button> */}

          {/* Viewport */}
          <div className="overflow-hidden px-0 md:px-16">
            {/* Moving track */}
            <div className="airline-track flex w-max gap-3 md:gap-4">
              {infiniteAirlines.map((airline, index) => (
                <div
                  key={`${airline.name}-${index}`}
                  className="flex h-[160px] w-[210px] shrink-0 flex-col items-center justify-between rounded-xl border border-[#d5edf4] bg-white px-5 py-7 shadow-[0_4px_18px_rgba(40,150,190,0.07)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(40,150,190,0.12)] sm:w-[220px] md:h-[180px] md:w-[230px]"
                >
                  {/* Logo */}
                  <div className="flex h-[155px] w-full items-center justify-center">
                    <img
                      src={airline.logo}
                      alt={airline.name}
                      className="max-h-[82px] max-w-[165px] object-contain"
                    />
                  </div>

                  {/* Name */}
                  <p className="text-center text-[17px] font-medium text-[#40566d] md:pt-0 pt-4">
                    {airline.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Infinite animation */}
      <style>{`
        .airline-track {
          animation: airlineInfinite 35s linear infinite;
        }

        .airline-track:hover {
          animation-play-state: paused;
        }

        @keyframes airlineInfinite {
          from {
            transform: translateX(0);
          }

          to {
            transform: translateX(calc(-50% - 8px));
          }
        }

        @media (max-width: 768px) {
          .airline-track {
            animation-duration: 28s;
          }
        }
      `}</style>
    </section>
  );
};

export default AirlinesSlider;
